/* 
 * Export component file to be used on project
*/

import DashboardFilters from './DashboardFilters.js';
export default DashboardFilters;
